export const DragModes = Object.freeze({
  Resize: 'resize',
  Select: 'select'
})

export const GestureTargetTypes = Object.freeze({
  None: 'none',
  Header: 'header',
  BelowRows: 'belowRows',
  Row: 'row'
})

export const SortOrders = Object.freeze({
  Ascending: true,
  Descending: false,
  None: null,
  Toggle: 'toggle'
})
